var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/status/price_query2_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "priceCheck",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 21,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/status/price_query2_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9305 1.60977C12.6711 1.35034 12.3675 1.21546 12.0049 1.14114C11.6894 1.07649 11.2738 1.04677 10.7214 1.02894C9.78432 0.998686 8.25654 0.999309 5.72516 1.00034L5.72513 1.00034C5.22385 1.00055 4.68321 1.00077 4.1 1.00077C3.51648 1.00077 2.99208 1.24243 2.61687 1.61764C2.24167 1.99285 2 2.51724 2 3.10077V10.4508C2 11.0314 2.23601 11.5583 2.6195 11.9418L12.0695 21.3918C12.454 21.7763 12.983 22.0008 13.55 22.0008C14.1098 22.0008 14.6389 21.7806 15.025 21.3869L22.3765 14.0353C22.7749 13.6446 23 13.1175 23 12.5508C23 11.9666 22.7558 11.4351 22.3805 11.0598L12.9305 1.60977ZM4.1 3.00077C4.68864 3.00077 5.23238 3.00056 5.73484 3.00036C8.27068 2.99937 9.7554 2.99879 10.6569 3.0279C11.1883 3.04506 11.4532 3.07144 11.5901 3.09779L20.9663 12.474C20.9755 12.4832 20.9849 12.4964 20.9914 12.5118C20.9977 12.5265 21 12.5397 21 12.5508C21 12.5674 20.997 12.5767 20.9948 12.5818C20.9926 12.5871 20.9878 12.5959 20.9757 12.6076L13.6066 19.9767L13.597 19.9866C13.5942 19.9895 13.5903 19.9925 13.5842 19.995C13.5782 19.9975 13.5673 20.0008 13.55 20.0008C13.5148 20.0008 13.4941 19.988 13.4837 19.9776L4.03371 10.5276C4.02021 10.514 4.01216 10.501 4.00748 10.49C4.00304 10.4795 4 10.4671 4 10.4508V3.10077C4 3.07929 4.00799 3.05496 4.03109 3.03186C4.05419 3.00875 4.07852 3.00077 4.1 3.00077ZM5.05457 5.6303C5.05457 6.5018 5.75807 7.2053 6.62957 7.2053C7.50107 7.2053 8.20457 6.5018 8.20457 5.6303C8.20457 4.7588 7.50107 4.0553 6.62957 4.0553C5.75807 4.0553 5.05457 4.7588 5.05457 5.6303Z",
    fill: "#5D6B72"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#priceCheck)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 24,
    height: 24,
    fill: "#5D6B72"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceCheckIcon);
export default __webpack_public_path__ + "static/media/PriceCheckIcon.9bb33d0e.svg";
export { ForwardRef as ReactComponent };